import { v4 as uuid } from 'uuid'

// success
// info
// warning
// error

const timeouts = {}

const getInitialState = () => ({
  messages: [],
})

const state = getInitialState()

const getErrorConf = response => {
  const code = response?.data?.detail?.code || response?.data?.code
  if (code === 'token_not_valid') {
    return { visible: false }
  }

  const res = response?.data?.detail || response?.data
  if (res?.text) {
    if (Array.isArray(res.text)) {
      return { text: res.text.join(', '), visible: true }
    }
    return { text: res.text, visible: true }
  }

  // console.log(res)
  return {
    // text: `Unknown error - ${JSON.stringify(response)}`, visible: true,
    // text: `Unknown error - status: ${response.status}`, visible: true,
    unknown_error: !res,
    text: res || `Unknown error - status:${response?.status || 'unknown'}`,
    visible: true,
  }
}

const actions = {
  messages_custom({ commit, dispatch, getters }, { id }) {
    // NON_ZERO_EV_FOLD, ZERO_RANGE, EVS_FREQUENCIES_MISMATCH, NEGATIVE_EV
    if (id === 'message_zero_frequency_line') {
      // http://localhost:8080/solutions/?gametype=Cash6m500zBasic&depth=100&history_spot=3&gmff_depth=100&gmff_type=basic&gmfft_sort_key=0&gmfft_sort_order=desc&preflop_actions=F-F-RAI
      const existingMessage = state.messages.find(
        m => m.visible && m.status === 'zero_frequency_line',
      )
      const showMesage = () => {
        dispatch('messages', {
          type: 'warning',
          icon: 'mdi-alert-circle-outline',
          status: 'zero_frequency_line',
          statusMessages: {
            _zero_frequency_line: {
              i18n: 'messages.zero_frequency_line',
              link: {
                url: 'https://blog.gtowizard.com/understanding-nash-distance/',
                i18n: 'btn.read_more',
                sameLine: true,
              },
            },
          },
          css_style: {
            '--back-opacity': '0.5',
            '--back-padding': '0.25rem 1rem',
            '--font-icon': '1rem',
            '--gap': '0.5rem',
            '--font-size': '1rem',
            border: '1px solid var(--clr-back)',
            '--close-font-size': '1rem',
            'border-radius': '6px',
            top: '-0.325rem',
            position: 'relative',
          },
          hideTimeout: 3000,
        })
      }
      if (existingMessage) {
        // so it catches attention and you notice
        commit('messages', { ...existingMessage, visible: false })
        setTimeout(() => {
          showMesage()
        }, 333)
        return
      }
      showMesage()
    }
  },
  messages({ commit, dispatch }, { type, error, ...rest }) {
    let message = {
      id: uuid(),
      visible: true,
      type,
      ...rest,
    }

    const response = error?.response
    // const response = undefined
    if (error) {
      const errorConf = getErrorConf(response)
      message = {
        ...message,
        statusMessages:
          response?.status === 400 && response?.data?.text ? null : message?.statusMessages,
        error,
        unknown_error: false,
        status: message?.status || response?.status,
        text: errorConf?.text || '',
        visible: errorConf?.visible,
      }
    }
    // console.log(message)
    commit('messages', message)
    if (!message.hide && !message.hideTimeout) {
      return
    }
    clearTimeout(timeouts[message.id])
    timeouts[message.id] = setTimeout(() => {
      commit('messages', {
        ...message,
        visible: false,
      })
      delete timeouts[message.id]
    }, message.hideTimeout || 1700)

    // console.log(timeouts)

    if (error) {
      console.log({ message, type, error, ...rest })
      throw new Error('Api call error')
    }
  },
}

const getters = {
  messages(state) {
    const messages = state.messages.filter(m => m.visible)
    return messages
  },
}
const mutations = {
  messages_reset(state) {
    state.messages = []
  },
  messages(state, message) {
    const messageIdx = state.messages.findIndex(m => m.id === message.id)
    if (messageIdx !== -1) {
      const messages = JSON.parse(JSON.stringify(state.messages))
      messages[messageIdx] = message
      state.messages = messages
    } else {
      state.messages = [...state.messages, message]
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
